// Helper genérico de lectura/escritura de `Extension[]` sobre cualquier recurso FHIR
// (Fase 2 del roadmap de formularios MSP — ver PLAN.md, "001 — filiación nueva").
// Hasta ahora cada campo-extensión se manejaba a mano (ver EXT_OCUPACION en
// DatosDemograficosTab.tsx, el único precedente) — con 10+ campos nuevos de filiación
// ese patrón se repetiría 10 veces; acá se generaliza una sola vez. Puro, sin FHIR
// client, testeable sin red ni DOM.
import type { Coding, Extension } from '@medplum/fhirtypes';

export function valorExtensionTexto(extensiones: readonly Extension[] | undefined, url: string): string {
  return extensiones?.find((e) => e.url === url)?.valueString ?? '';
}

export function valorExtensionCoding(extensiones: readonly Extension[] | undefined, url: string): Coding | undefined {
  return extensiones?.find((e) => e.url === url)?.valueCodeableConcept?.coding?.[0];
}

/**
 * Reconstruye un array de `Extension[]` reemplazando (o quitando) un conjunto de
 * `url` a la vez, preservando cualquier otra extensión existente que no esté en la
 * lista de cambios. `extension: undefined` en un cambio quita esa `url` sin
 * reemplazarla (equivalente a "el campo quedó vacío").
 */
export function reemplazarExtensiones(actuales: readonly Extension[] | undefined, cambios: readonly { url: string; extension: Extension | undefined }[]): Extension[] {
  const urlsCambiadas = new Set(cambios.map((c) => c.url));
  const preservadas = (actuales ?? []).filter((e) => !urlsCambiadas.has(e.url));
  const nuevas = cambios.map((c) => c.extension).filter((e): e is Extension => e !== undefined);
  return [...preservadas, ...nuevas];
}
